import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AuthenticationService } from 'src/app/data-services/authentication.service';
import { UserService } from 'src/app/data-services/user.service';
import { first, map } from 'rxjs/operators';
import { PostService } from 'src/app/data-services/post.service';
import { from } from 'rxjs';
import { NgForm, FormGroup, Validators, FormBuilder, FormControl } from '@angular/forms';
import { Gallery, GalleryItem, ImageItem, ThumbnailsPosition, ImageSize } from '@ngx-gallery/core';

@Component({
  selector: 'app-photos',
  templateUrl: './photos.component.html',
  styleUrls: ['./photos.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PhotosComponent implements OnInit {
  albumForm: FormGroup;
  currentUser: any;
  userData: any = {};
  photos : any;
  items: GalleryItem[];

  constructor(
    private authenticationService: AuthenticationService,
    private userService: UserService,
    private postService: PostService,
    private formBuilder: FormBuilder,
    public gallery: Gallery
  ) { }

  ngOnInit(): void {
    this.authenticationService.currentUser.subscribe(x => this.currentUser = x);
    const data = {
      userId: this.currentUser.success.user.id,
    };
    this.postService.getUserPhotos(data).pipe(first()).subscribe(
      res => {
      this.photos = res;
      console.log(this.photos);
    });
  }
}

